
export default {
    props: ['error'],
    components: {
        Breadcrumbs: () => import('~/components/Breadcrumbs'),
        SkeletonBreadcrumbs: () => import('~/components/skeletons/SkeletonBreadcrumbs.vue')
    },
    data() {
        return {
            isPreloaderProducts: true,
            breadcrumbs: [
                {
                    route: '/',
                    title: this.$t('farmacie.error')
                }
            ]
        };
    },
    computed: {
        getImage() {
            return this.$store.state.global.globalSettings.images.image404;
        },
        productsHaveBeenLoaded() {
            return this.isPreloaderProducts === false;
        }
    },
    async fetch() {
        this.isPreloaderProducts = false;
    },
    fetchOnServer: true,
    fetchKey: 'site-error'
};
